import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { MssqlParameter } from "../driver/sqlserver/MssqlParameter";
import { Table } from "../schema-builder/table/Table";
import { v4 as uuidv4 } from "uuid";
/**
 * Caches query result into current database, into separate table called "query-result-cache".
 */
export var DbQueryResultCache = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function DbQueryResultCache(connection) {
    _classCallCheck(this, DbQueryResultCache);
    this.connection = connection;
    var schema = this.connection.driver.options.schema;
    var database = this.connection.driver.database;
    var cacheOptions = typeof this.connection.options.cache === "object" ? this.connection.options.cache : {};
    var cacheTableName = cacheOptions.tableName || "query-result-cache";
    this.queryResultCacheDatabase = database;
    this.queryResultCacheSchema = schema;
    this.queryResultCacheTable = this.connection.driver.buildTableName(cacheTableName, schema, database);
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates a connection with given cache provider.
   */
  _createClass(DbQueryResultCache, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Disconnects with given cache provider.
     */
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function disconnect() {
        return _disconnect.apply(this, arguments);
      }
      return disconnect;
    }()
    /**
     * Creates table for storing cache if it does not exist yet.
     */
  }, {
    key: "synchronize",
    value: function () {
      var _synchronize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(queryRunner) {
        var driver, tableExist;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              queryRunner = this.getQueryRunner(queryRunner);
              driver = this.connection.driver;
              _context3.next = 4;
              return queryRunner.hasTable(this.queryResultCacheTable);
            case 4:
              tableExist = _context3.sent;
              if (!tableExist) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return");
            case 7:
              _context3.next = 9;
              return queryRunner.createTable(new Table({
                database: this.queryResultCacheDatabase,
                schema: this.queryResultCacheSchema,
                name: this.queryResultCacheTable,
                columns: [{
                  name: "id",
                  isPrimary: true,
                  isNullable: false,
                  type: driver.normalizeType({
                    type: driver.mappedDataTypes.cacheId
                  }),
                  generationStrategy: driver.options.type === "spanner" ? "uuid" : "increment",
                  isGenerated: true
                }, {
                  name: "identifier",
                  type: driver.normalizeType({
                    type: driver.mappedDataTypes.cacheIdentifier
                  }),
                  isNullable: true
                }, {
                  name: "time",
                  type: driver.normalizeType({
                    type: driver.mappedDataTypes.cacheTime
                  }),
                  isPrimary: false,
                  isNullable: false
                }, {
                  name: "duration",
                  type: driver.normalizeType({
                    type: driver.mappedDataTypes.cacheDuration
                  }),
                  isPrimary: false,
                  isNullable: false
                }, {
                  name: "query",
                  type: driver.normalizeType({
                    type: driver.mappedDataTypes.cacheQuery
                  }),
                  isPrimary: false,
                  isNullable: false
                }, {
                  name: "result",
                  type: driver.normalizeType({
                    type: driver.mappedDataTypes.cacheResult
                  }),
                  isNullable: false
                }]
              }));
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function synchronize(_x) {
        return _synchronize.apply(this, arguments);
      }
      return synchronize;
    }()
    /**
     * Caches given query result.
     * Returns cache result if found.
     * Returns undefined if result is not cached.
     */
  }, {
    key: "getFromCache",
    value: function getFromCache(options, queryRunner) {
      queryRunner = this.getQueryRunner(queryRunner);
      var qb = this.connection.createQueryBuilder(queryRunner).select().from(this.queryResultCacheTable, "cache");
      if (options.identifier) {
        return qb.where("".concat(qb.escape("cache"), ".").concat(qb.escape("identifier"), " = :identifier")).setParameters({
          identifier: this.connection.driver.options.type === "mssql" ? new MssqlParameter(options.identifier, "nvarchar") : options.identifier
        }).getRawOne();
      } else if (options.query) {
        if (this.connection.driver.options.type === "oracle") {
          return qb.where("dbms_lob.compare(".concat(qb.escape("cache"), ".").concat(qb.escape("query"), ", :query) = 0"), {
            query: options.query
          }).getRawOne();
        }
        return qb.where("".concat(qb.escape("cache"), ".").concat(qb.escape("query"), " = :query")).setParameters({
          query: this.connection.driver.options.type === "mssql" ? new MssqlParameter(options.query, "nvarchar") : options.query
        }).getRawOne();
      }
      return Promise.resolve(undefined);
    }
    /**
     * Checks if cache is expired or not.
     */
  }, {
    key: "isExpired",
    value: function isExpired(savedCache) {
      var duration = typeof savedCache.duration === "string" ? parseInt(savedCache.duration) : savedCache.duration;
      return (typeof savedCache.time === "string" ? parseInt(savedCache.time) : savedCache.time) + duration < new Date().getTime();
    }
    /**
     * Stores given query result in the cache.
     */
  }, {
    key: "storeInCache",
    value: function () {
      var _storeInCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options, savedCache, queryRunner) {
        var shouldCreateQueryRunner, insertedValues, qb, _qb;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              shouldCreateQueryRunner = queryRunner === undefined || (queryRunner === null || queryRunner === void 0 ? void 0 : queryRunner.getReplicationMode()) === "slave";
              if (queryRunner === undefined || shouldCreateQueryRunner) {
                queryRunner = this.connection.createQueryRunner("master");
              }
              insertedValues = options;
              if (this.connection.driver.options.type === "mssql") {
                // todo: bad abstraction, re-implement this part, probably better if we create an entity metadata for cache table
                insertedValues = {
                  identifier: new MssqlParameter(options.identifier, "nvarchar"),
                  time: new MssqlParameter(options.time, "bigint"),
                  duration: new MssqlParameter(options.duration, "int"),
                  query: new MssqlParameter(options.query, "nvarchar"),
                  result: new MssqlParameter(options.result, "nvarchar")
                };
              }
              if (!(savedCache && savedCache.identifier)) {
                _context4.next = 11;
                break;
              }
              // if exist then update
              qb = queryRunner.manager.createQueryBuilder().update(this.queryResultCacheTable).set(insertedValues);
              qb.where("".concat(qb.escape("identifier"), " = :condition"), {
                condition: insertedValues.identifier
              });
              _context4.next = 9;
              return qb.execute();
            case 9:
              _context4.next = 21;
              break;
            case 11:
              if (!(savedCache && savedCache.query)) {
                _context4.next = 18;
                break;
              }
              // if exist then update
              _qb = queryRunner.manager.createQueryBuilder().update(this.queryResultCacheTable).set(insertedValues);
              if (this.connection.driver.options.type === "oracle") {
                _qb.where("dbms_lob.compare(\"query\", :condition) = 0", {
                  condition: insertedValues.query
                });
              } else {
                _qb.where("".concat(_qb.escape("query"), " = :condition"), {
                  condition: insertedValues.query
                });
              }
              _context4.next = 16;
              return _qb.execute();
            case 16:
              _context4.next = 21;
              break;
            case 18:
              // Spanner does not support auto-generated columns
              if (this.connection.driver.options.type === "spanner" && !insertedValues.id) {
                insertedValues.id = uuidv4();
              }
              // otherwise insert
              _context4.next = 21;
              return queryRunner.manager.createQueryBuilder().insert().into(this.queryResultCacheTable).values(insertedValues).execute();
            case 21:
              if (!shouldCreateQueryRunner) {
                _context4.next = 24;
                break;
              }
              _context4.next = 24;
              return queryRunner.release();
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function storeInCache(_x2, _x3, _x4) {
        return _storeInCache.apply(this, arguments);
      }
      return storeInCache;
    }()
    /**
     * Clears everything stored in the cache.
     */
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(queryRunner) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.getQueryRunner(queryRunner).clearTable(this.queryResultCacheTable));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function clear(_x5) {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
    /**
     * Removes all cached results by given identifiers from cache.
     */
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(identifiers, queryRunner) {
        var _this = this;
        var _queryRunner;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _queryRunner = queryRunner || this.getQueryRunner();
              _context6.next = 3;
              return Promise.all(identifiers.map(function (identifier) {
                var qb = _queryRunner.manager.createQueryBuilder();
                return qb.delete().from(_this.queryResultCacheTable).where("".concat(qb.escape("identifier"), " = :identifier"), {
                  identifier: identifier
                }).execute();
              }));
            case 3:
              if (queryRunner) {
                _context6.next = 6;
                break;
              }
              _context6.next = 6;
              return _queryRunner.release();
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function remove(_x6, _x7) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Gets a query runner to work with.
     */
  }, {
    key: "getQueryRunner",
    value: function getQueryRunner(queryRunner) {
      if (queryRunner) return queryRunner;
      return this.connection.createQueryRunner();
    }
  }]);
  return DbQueryResultCache;
}();